<template>
  <div class="email-form" v-if="isLoggedIn">
    <Attention v-if="errorMessage" :text="errorMessage"/>
    <form-area name="frm" :action="action" method="post" novalidate="true">
      <input type="hidden" name="_token" :value="token">

      <div class="email-form__body">
        <form-input
          name="new_email"
          type="email"
          v-model="newEmail"
          placeholder="例）uranaitv@uranai.tv"
          label="新しいメールアドレス"
          :validation="{
            email: false,
            duplicateEmail: true,
            nonRfcEmailCheck: true,
            required: false,
            confirmed: newEmailConfirm
          }"
          @validate="validate"
        ></form-input>

        <form-input
          name="new_email_confirm"
          type="email"
          v-model="newEmailConfirm"
          label="新しいメールアドレス（確認）"
          :validation="{
            email: false,
            duplicateEmail: true,
            nonRfcEmailCheck: true,
            required: false
          }"
          @validate="validate"
        ></form-input>
      </div>

      <ul class="note-list">
        <li class="note-list__item">※info@uranai.tvからメールアドレス変更用URLを送信します。メールの設定により、迷惑メールフォルダに振り分けられる場合があります。</li>
        <li class="note-list__item">※キャリアメールをご利用の方でメールが届かない場合は、ドメイン指定を解除してください。</li>
      </ul>
      
      <div class="email-form__foot">
        <SubmitButton
          type="submit"
          text="送信"
          :disabled="newEmail === '' || newEmailConfirm === '' || formErrors.length !== 0"
          @click="clickSubmit"
        />
      </div>
    </form-area>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

import Attention from '../common/Attention'
import SubmitButton from '../partials/SubmitButton'

export default {
  name: 'EmailForm',
  components: {
    Attention,
    SubmitButton
  },
  props: {
    action: String,
    method: String,
    token: String
  },
  data() {
    return {
      newEmail: '',
      newEmailConfirm: '',
      formErrors: [],
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters([ 'isLoggedIn']),
  },
  methods: {
    /**
     * 子コンポーネントからエラーを受け取る
     * @param {value} エラーデータ
     * @return {Void} formErrors に設定
     */
    validate (value) {
      if (value.items.length) {
        this.formErrors = value.items
      }
    },
    /**
     * submit ボタンの処理
     * @return {Void} errorMessage に設定
     */
    clickSubmit () {
      // エラーがあったら設定
      if (this.formErrors.length) {
        this.errorMessage = this.formErrors[0].msg
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.email-form {
  padding: 35px 4px 20px;
  &__body {
    padding: 0 10px;
    margin: 0 0 30px;
  }
  &__foot {
    padding: 0 10px;
  }
}
.note-list {
  display: block;
  margin: 0 0 36px;
  padding: 0;
  color: $col_base_black;
  font-size: 11px;
  line-height: 1.5;
  &__item {
    display: block;
    text-align: justify;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/EmailForm.vue